export const EmailAccountSignatureType = {
  Always: 'A',
  First: 'F',
  Never: 'N'
};
